
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/electric-commercial-vehicles/4w/Eka/K1.5",
      function () {
        return require("private-next-pages/electric-commercial-vehicles/4w/Eka/K1.5/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/electric-commercial-vehicles/4w/Eka/K1.5"])
      });
    }
  